export enum FollowingPages {
  LISTING,
  COACH,
}

export interface IUseFollowingCoach {
  page: FollowingPages;
}
